import React from 'react';

import ReactIDSwiperGallery from 'components/GalleryPage/ReactIDSwiperGallery';
import ReactPhotoGallery from 'components/GalleryPage/ReactPhotoGallery';
import imageManifest from 'static/imageManifest';
import 'styles/gallery.scss';

const reactIDSwiperText = 'Slideshow';
const reactPhotoGalleryText = 'Tile';

const unique = (l) => {
    var arr = [];
    for (var i = 0; i < l.length; i++) {
        if (!arr.includes(l[i])) {
            arr.push(l[i]);
        }
    }
    return arr;
}

// Subjects

// Animals
// Figure
// Plants



// Media



// Style

// Design
// Traditional

// Black and White
// Scientific Illustration
// Watercolor
// Colored Pencil
// Detail
// Medical Illustration
// Digital
// Plants
// Cartoon
// Marker
// Pencil
// Charcoal
// Oil

const makeInitialTags = () => {
    const subjects = [
        "Animals",
        "Figure",
        "Plants",
    ];

    const media = [
        "Digital",
        "Traditional",
    ];

    const style = [
        "Editorial",
        "Medical",
        "Scientific",
    ];

    const observedTags = unique([].concat(...(imageManifest.map(item => item.tags))));

    const misc = observedTags.filter(
        t => !(
            subjects.some(s => s === t) || media.some(s => s === t) || style.some(s => s === t)
        )
    );


    const b = (l, family) => l.map(item => Object.assign({ value: item, label: item, selected: false, family: family }))
    return b(subjects, 'Subjects').concat(b(media, 'Media')).concat(b(style, 'Style')).concat(b(misc, 'Misc'));
};

class GalleryOrganizer extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            tags: makeInitialTags(),
            photoset: imageManifest,
            text: reactIDSwiperText,
            shouldShowTagDropdown: true,
        }
        this.handleTagChange = this.handleTagChange.bind(this);
        this.setIDSwiper = this.setIDSwiper.bind(this);
        this.setPhoto = this.setPhoto.bind(this);
        this.makeButton = this.makeButton.bind(this);
        this.toggleTag = this.toggleTag.bind(this);
        this.toggleShouldShowTagDropdown = this.toggleShouldShowTagDropdown.bind(this);
    }

    handleTagChange = (tags) => {
        this.setState({ tags });
        if (tags.filter(t => t.selected).length === 0) {
            this.setState({ photoset: imageManifest });
        } else {
            this.setState({
                photoset: imageManifest.filter(
                    function (item) {
                        let flag = false;
                        tags.forEach(tag => {
                            if (item.tags.includes(tag.label) && tag.selected) {
                                flag = true;
                            }
                        }
                        );
                        return flag;
                    })
            })
        }
    };

    // flex-wrap enabled for mobile dropdown
    // update tag list

    setIDSwiper() {
        this.setState({
            gallery: <ReactIDSwiperGallery photoset={this.state.photoset.map(item => ({
                src: require('../../static/img/' + item.filename),
                width: item.width,
                height: item.height,
                thumbnailWidth: item.thumbnailWidth,
                thumbnailHeight: item.thumbnailHeight,
            }))} />,
            text: reactIDSwiperText,
        })
    }

    setPhoto() {
        this.setState({
            gallery: <ReactPhotoGallery photoset={this.state.photoset} />,
            text: reactPhotoGalleryText,
        })
    }

    makeButton(fn, text) {
        const buttonStyle = text === this.state.text ? 'button-blue' : 'button-gray';
        return <button className={buttonStyle} onClick={fn}> {text} </button>
    }

    toggleTag(tag) {
        var tags = this.state.tags;
        const idx = tags.findIndex(t => t.value === tag.value);
        if (tag.selected) {
            if (idx !== -1) {
                tags[idx].selected = false;
                this.handleTagChange(tags);
            } else {
                console.log('Error removing tag from selected, tag ', tag, ', final tags, ', tags)
            }
        } else {
            tags[idx].selected = true;
            this.handleTagChange(tags);
        }
    }

    toggleShouldShowTagDropdown() {
        this.setState({ shouldShowTagDropdown: !this.state.shouldShowTagDropdown });
    }

    makeTagButton(tag) {
        return (
            <button
                key={tag.label}
                className={tag.selected ? 'button-blue' : 'button-gray'}
                onClick={() => this.toggleTag(tag)}
            >
                {tag.label}
            </button>
        );
    }

    render() {
        const families = unique(this.state.tags.map(t => t.family));
        return (
            <div className='gallery-container'>
                <div className='empty' />
                {this.state.text === reactIDSwiperText &&
                    <div className='swiper-gallery-content'>
                        <ReactIDSwiperGallery
                            photoset={this.state.photoset.map(item => (
                                {
                                src: require('static/img/' + item.filename),
                                // width: item.width,
                                // height: item.height,
                                thumbnailWidth: item.thumbnailWidth,
                                thumbnailHeight: item.thumbnailHeight,
                                title: item.title,
                                caption: item.caption,
                                thumbnail: require('static/thumbnails/' + item.thumbnail),
                            }))}
                        />

                    </div>
                }
                {this.state.text === reactPhotoGalleryText &&
                    <div className='gallery-content'>

                        <ReactPhotoGallery
                            photoset={this.state.photoset.map(item => (
                                {
                                    src: require('static/img/' + item.filename),
                                    width: item.width / 10,
                                    height: item.height / 10,
                                    title: item.title,
                                    caption: item.caption,
                                }
                            ))}
                        />

                    </div>
                }
                <div className={this.shouldShowTagDropdown ? 'sidebar' : 'sidebar is-closed'}>
                    <button
                        className='nav-button'
                        onClick={this.toggleShouldShowTagDropdown}
                    >=</button>
                    {this.state.shouldShowTagDropdown ? (
                        <div className='dropdown-box'>
                            <h4 className='sidebarHeader'>View</h4>
                            <div className='viewPicker'>
                                {this.makeButton(this.setIDSwiper, reactIDSwiperText)}
                                {this.makeButton(this.setPhoto, reactPhotoGalleryText)}
                            </div>
                            <h4 className='sidebarHeader'>Tags</h4>
                            {families.map(f => <div className='tagPicker' key={f}>
                                {/* <h4 className='sidebarSubheader'>{f}</h4> */}
                                {this.state.tags
                                    .filter(t => t.family === f)
                                    .map(t => this.makeTagButton(t))}
                            </div>

                            )}
                            <div className='empty2' />
                        </div>
                    ) : null}
                </div>
            </div>
        )
    }
}

export default GalleryOrganizer;



// WEBPACK FOOTER //
// ./src/components/GalleryPage/GalleryOrganizer.js